module.exports = __webpack_public_path__ + "img/event-1.ea6014f.jpg";